import { Method } from 'axios';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface OnlyFansMetricsPartner {
    _id?: string;
    name: string;
    website: string;
    description?: string;
    method: Method;
    url: string;
    headers?: { [key: string]: string };
    parameters?: { [key: string]: string };
    active: boolean;
}

const useSextforceMetricsPartners = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch Metrics Partners
    const fetchData = async (): Promise<OnlyFansMetricsPartner[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/metricsPartners`;

        const data = await axios
            .get(query)
            .then(async response => response.data as OnlyFansMetricsPartner[])
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    const query = useQuery(['metricsPartners', params.userId], () => fetchData(), {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
    });

    return { ...query };
};

export default useSextforceMetricsPartners;
